define('views/blocks/OgoneDirectView',['jquery', 'underscore', 'backbone', 'router', 'app', 'SubView', 'ApiRequest',

        'template!blocks/payments/ogone', 'template!blocks/payments/card-radio-field', 'UrlFactory'],
    function ($, _, Backbone, router, app, SubView, ApiRequest, ogoneTemplate, cardRadioFieldTemplate, UrlFactory) {

        function isInteger(num){
            return (num ^ 0) === num;
        }


        var view, paymentMethod, store, brands, cards, selectedCard, ignore_brand_selection;

        var OgoneView = Backbone.View.extend(SubView).extend({
            //
            className: 'ogone',
            //
            events: {
                'change :radio[name=brand], [name=storepermently]': 'openAddCard',
                'change :radio[name=card]': 'selectCard',
                'click .removeCard': 'removeCard',
                'click button.other-card': 'openOtherCard',
                'change .cvc': 'changeCVC',
            },
            initialize: function (options) {

                view = this;
                view.subviews = [];
                paymentMethod = options.paymentMethod;
                view.listenTo(app,'CVCError',view.onCVCError);

                console.log('initialize Ogone view',view.cid);

                if (!_.isUndefined(options.id_store)) {
                    view.id_store = options.id_store;
                    store = app.getStore(options.id_store);
                } else {
                    view.id_store = false;
                }

                //
                if(store){
                    // force l'utilisation modifier store
                    paymentMethod = store.getPaymentMethods().get(paymentMethod.id);
                }

                ignore_brand_selection = paymentMethod.get('ignore_brand_selection');

                brands = _(paymentMethod.get('brand'));
                console.log(brands,paymentMethod.toJSON());

                brands.each(function (brand) {
                    var picture = brand.picture;
                    if (picture && isInteger(parseInt(picture))) {
                        // converti les identifiants en URL...
                        brand.pictureUrl = UrlFactory.getUrlPicture(picture, 'paymentbrand', '50x50', brand.brand, 'png');
                    }
                });

                if (!_.isUndefined(options.onlySave)) {
                    view.onlySave = options.onlySave;
                } else {
                    view.onlySave = false;
                }
                cards = app.getCustomer().getCards(brands.pluck('brand'));

                view.render();
                view.listenTo(app, 'onOgoneIframeSuccess', view.onIframeSuccess);
            },
            render: function () {

                var hasAvailableCard = cards.size() > 0,
                    onlySave = view.onlySave,
                    cartRequireCVC = onlySave ? false : app.getCart().requireCVC();
                selectedCard = cards.first();

                view.$el.html(ogoneTemplate({
                    brands: brands,
                    cards: cards,
                    onlySave: onlySave,
                    hasAvailableCard: hasAvailableCard,
                    ignore_brand_selection: ignore_brand_selection,
                    cartRequireCVC:cartRequireCVC
                }));

                if(brands.size()>0) {
                    // si il n'y a pas de carte enregistrées
                    // on affiche le champs pour ajouter une carte
                    view.displayAddCardForm(!hasAvailableCard, 'default');

                    // si on a des cartes, on les affiches
                    view.displayListCardForm(hasAvailableCard);

                    // on affiche la carte selectionnée (par défaut aucune)
                    view.displaySelectCard();

                    //setTimeout(function () {
                    // after view appened in DOM
                    if (hasAvailableCard) {
                        view.selectCard();
                    }
                    //}, 1);
                    //
                    //
                }
                view.delegateEvents();
            },
            displayListCardForm: function (show) {
                var blockListCards = view.$('.ogone-list-cards');
                if (show) {
                    blockListCards.show();
                } else {
                    blockListCards.hide();
                }
            },
            displayAddCardForm: function (show, mode) {
                var blockAddCard = view.$('.ogone-add-card'),
                    titleUseOther = view.$('.title-use-other-card').hide(),
                    titleUseNew = view.$('.title-use-new-card').hide(),
                    brands = view.$('[name=brand]'),
                    cvc = view.$('.selected-card-value .cvc');
                if (show) {
                    blockAddCard.show();
                    brands.eq(0).prop('checked', true);
                    cvc.addClass('require-cvc');
                    cvc.focus();
                    switch (mode) {
                        default :
                        case 'default':
                            view.openAddCard();
                            break;
                        case 'new' :
                            titleUseNew.show();
                            break;
                        case 'other' :
                            titleUseOther.show();
                            break;
                    }
                } else {
                    blockAddCard.hide();
                    titleUseOther.hide();
                    titleUseNew.hide();
                }
            },
            openAddCard: function (e) {
                selectedCard = false;
                view.displaySelectCard();
                //          view.$('[name=card]').prop('checked',false);
                var brand = brands.findWhere({id_payment_method_brand: view.$('[name=brand]:checked').val()});
                var cart = app.getCart(),
                    id_store,
                    storepermently,
                    requestParams = {
                        id_payment_method: paymentMethod.id,
                        // TODO utiliser la valeur du panier, en dur pour le test
                        attach_to_cart: true,
                    },
                    storePermentlyCheckbox = view.$('[name=storepermently]'),
                    storePermentlyCheckboxGroup = view.$('.store-permently'),
                    noDirectLinkMessage = view.$('.no-directlink-message');


                if(ignore_brand_selection){
                    //
                    // iframe Ingenico Connect sans sélecteur de marque (VISA/MASTERCARD/AMEX)
                    //
                    if(!_.isUndefined(e) && storePermentlyCheckbox.is(e.currentTarget)){
                        // quand on clique sur le bouton storepermently, pas besoin de recharger la iframe
                      //  return;
                    }

                }else if(brand.directlink === '0'){
                    //
                    // soumission de formulaire classique
                    //
                    paymentMethod.options.params = _(brand).pick('id_payment_method_brand','brand','directlink');
                    view.$('.iframe-add-card').html('');
                    noDirectLinkMessage.show();
                    storePermentlyCheckboxGroup.hide();
                    return;
                }else{
                    //
                    // iframe Ogone Standard
                    //
                    //console.log('brand', brand, 'brands', brands);
                    requestParams.cbBrand = brand ? brand.brand : '';
                }

                //
                storepermently = ((view.onlySave == true) || storePermentlyCheckbox.is(':checked')) ? 'Y' : 'N';
                requestParams.storepermently = storepermently;
                //
                id_store = (!_.isUndefined(view.id_store) && view.id_store != false) ? view.id_store : cart.get('id_store');
                requestParams.id_store = id_store;
                //
                storePermentlyCheckboxGroup.show();
                noDirectLinkMessage.hide();
                //
                ApiRequest('ToolsPaymentMethod',requestParams,{method: 'getCbEncrypt'})
                    .done(function (data) {
                        view.$('.iframe-add-card').html(data.iframe);
                    })
                    .fail(function(){
                        app.blockError(view.$('.iframe-add-card'));
                        app.error('ToolsPaymentMethodError',requestParams);
                    });
            },
            cleanAddCardForm: function () {
                view.$('[name=brand]').prop('checked', false);
                view.$('.iframe-add-card iframe').remove();
            },
            selectCard: function () {
                var radios = view.$('[name=card]'),
                    radio = radios.filter(':checked'),
                    cvc = radio.siblings('.cvc'),
                    selection = radio.val();
                view.$('.cvc').removeClass('require-cvc');
                cvc
                    .show()
                    .toggleClass('require-cvc', cvc.data('require-cvc') == true) //
                    .focus();
                radio.siblings('.cvc').show().focus();
                view.cleanAddCardForm();
                switch (selection) {
                    case 'new':
                        view.displayAddCardForm(true, 'other');
                        view.openAddCard();
                        break;
                    default :
                        view.displayAddCardForm(false);
                }
                selectedCard = cards.findWhere({id_card: selection});
                if (view.onlySave == false)
                    paymentMethod.options.params = selectedCard;
                view.displaySelectCard();
                view.delegateEvents();
            },
            displaySelectCard: function () {
                var cardLabel = '';

                if (selectedCard) {
                    cardLabel = _.template('<%= cardNum %> <%= brand %>')(selectedCard);
                }
                if (selectedCard && (selectedCard.storing == "0")) {
                    view.$('.selected-card').show();
                } else {
                    view.$('.selected-card').hide();
                }
                view.$('.selected-card .value').html(cardLabel);
            },
            openOtherCard: function () {
                view.$('[name=card]').prop('checked', false);
                view.$('[name=card]#new').prop('checked', true);
                view.displayAddCardForm(true, 'other');
                view.openAddCard();
            },
            removeCard: function (e) {
                var currentTarget = $(e.currentTarget),
                    id_card = currentTarget.data('idcard');
                currentTarget.closest('div').remove()
                app.getCustomer().removeCard(id_card);

            },
            changeCVC: function (e) {
                // Card Verification Code
                paymentMethod.options.params.cvc = e.currentTarget.value;
            },
            onCVCError: function(e){
                $('[name=card]:checked + label + .cvc, .selected-card .cvc:visible')
                    .addClass('require-cvc warning');
                $('.require-cvc').focus();
            },
            onIframeSuccess: function (card) {
                view.cleanAddCardForm();
                console.log('onIframeSuccess');
                if (card.status === 'success') {
                    console.log('onOgoneIframeSuccess', card);
                    //
                    if(ignore_brand_selection){
                        // overwrite storing for Ingenico Connect
                        card.storing = view.$('[name=storepermently]').is(':checked') ? 1:0;
                    }
                    //
                    var cardStoring = card.storing == '1',
                        customer = app.getCustomer();
                    if (cardStoring) {
                        cards = customer.getCards();
                        cards.push(card);
                        app.getCustomer().set('card', cards.toArray());

                        view.$('.cards .other-card').before($(cardRadioFieldTemplate({
                            checked:true,
                            card:card,
                            onlySave:view.onlySave,
                            cartRequireCVC:true
                        })));

                    }
                    view.displayListCardForm(cardStoring || (cards.size() > 0));
                    view.displayAddCardForm(false);

                    selectedCard = card;
                    if (view.onlySave == false)
                        paymentMethod.options.params = selectedCard;
                    view.displaySelectCard();

                    view.delegateEvents();
                } else if (card.status === 'failure') {
                    // bloque les erreurs récursives
                    app.alert({title:app.t('Erreur','UI'),subtitle:card.message,callback:function(){
                            view.displayAddCardForm(true);
                            view.openAddCard();
                        }});
                }


            },
            validate: function () {
                console.log('validate', selectedCard);
            },


            submit: function (e) {
                e.preventDefault();
            }

        });

        return OgoneView;
    });

